import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import { selectors } from '../reducers/portaliPages';
import routeRegister from '../../../helpers/routeRegister';
import { generateRoutes } from '../../../helpers/portaleModuleHelper';
// import helper from '../../../helpers/steinerHelper';


const routes = generateRoutes('pagine', selectors);

const list = _.values(routes.list).map(route => ({
    ...route,
    requiredRoles: ['admin', 'developer', 'employee', 'amministrazione'],
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'portaliPages' */ `modules/portaliPages/${
                route.componentPath
            }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('portaliPages', routes.patterns);
routeRegister.addLinks('portaliPages', links);

export default list;
